// hooks/useAppEnvironment.js
import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../context/AuthContext';

export const useAppEnvironment = () => {
  const { user } = useAuth();
  const [env, setEnv] = useState({ isMobile: false, lang: 'es' });

  useEffect(() => {
    const init = async () => {
      // 1. Detectar plataforma
      const platform = Capacitor.getPlatform();
      const isMobile = platform === 'ios' || platform === 'android';

      // 2. Detectar idioma (navigator.language es 'es-ES' o 'en-US')
      const lang = user && user.lang ? user.lang : navigator.language.startsWith('es') ? 'es' : 'en';

      setEnv({ isMobile, lang });
    };
    init();
  }, []);

  return env;
};